const API_BASE = window.location.hostname === 'localhost'
  ? 'http://localhost:8000/api/realty'
  : `${window.location.origin}/api/realty`;

function getToken() {
  return localStorage.getItem('xr_token');
}

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  const token = getToken();
  if (token) headers['Authorization'] = `Token ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401 && token) {
    // Stale/invalid token (e.g. from before a backend migration) - clear it and
    // reload so the app re-authenticates fresh instead of getting stuck.
    localStorage.removeItem('xr_token');
    window.location.reload();
    return new Promise(() => {}); // halt this call, the reload takes over
  }

  const contentType = res.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await res.json() : null;

  if (!res.ok) {
    const message = data && (data.error || data.detail) ? (data.error || data.detail) : `Request failed (${res.status})`;
    throw new Error(message);
  }
  return data;
}

export const realtyApi = {
  piLogin: (accessToken) =>
    request('/auth/pi-login/', { method: 'POST', body: JSON.stringify({ accessToken }) }),

  listProperties: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/properties/${qs ? `?${qs}` : ''}`);
  },

  getProperty: (id) => request(`/properties/${id}/`),

  createProperty: (formData) =>
    fetch(`${API_BASE}/properties/`, {
      method: 'POST',
      headers: { Authorization: `Token ${getToken()}` },
      body: formData,
    }).then(async (res) => {
      const data = await res.json();
      if (!res.ok) throw new Error(JSON.stringify(data));
      return data;
    }),

  myProperties: () => request('/properties/?mine=true'),

  closeDeal: (id, payload) =>
    request(`/properties/${id}/close_deal/`, { method: 'POST', body: JSON.stringify(payload) }),

  sendInquiry: (payload) =>
    request('/inquiries/create/', { method: 'POST', body: JSON.stringify(payload) }),

  myInquiries: () => request('/inquiries/mine/'),

  agentProfile: () => request('/agent-profile/'),

  rateAgent: (payload) =>
    request('/agents/rate/', { method: 'POST', body: JSON.stringify(payload) }),
  agentRatings: (agentId) => request(`/agents/${agentId}/ratings/`),

  savedSearches: () => request('/saved-searches/'),
  saveSearch: (payload) =>
    request('/saved-searches/', { method: 'POST', body: JSON.stringify(payload) }),
  deleteSavedSearch: (id) =>
    request(`/saved-searches/${id}/`, { method: 'DELETE' }),

  compareProperties: (propertyIds) =>
    request('/properties-compare/', { method: 'POST', body: JSON.stringify({ property_ids: propertyIds }) }),
};

export const realtyPiApi = {
  approve: (payload) =>
    request('/pi/approve/', { method: 'POST', body: JSON.stringify(payload) }),
  complete: (payload) =>
    request('/pi/complete/', { method: 'POST', body: JSON.stringify(payload) }),
};

export function setRealtyToken(token) {
  localStorage.setItem('xr_token', token);
}
export function clearRealtyToken() {
  localStorage.removeItem('xr_token');
}
export function isRealtyLoggedIn() {
  return !!getToken();
}
